module.exports = __webpack_public_path__ + "static/media/on-regional.8b4ff757.png";